import { render, staticRenderFns } from "./tabContactsTypes.vue?vue&type=template&id=eaec4e0a&scoped=true"
import script from "./tabContactsTypes.vue?vue&type=script&lang=js"
export * from "./tabContactsTypes.vue?vue&type=script&lang=js"
import style0 from "./tabContactsTypes.vue?vue&type=style&index=0&id=eaec4e0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaec4e0a",
  null
  
)

export default component.exports